export default "__VITE_ASSET__99c259d7__"